export enum TermCategory {
    Order = 'order',
    Settlement = 'settlement',
    PayLink = 'paylink',
    Currency = 'currency',
    Country = 'country',
    Status = 'status',
    StoreId = 'storeId',
    Reference = 'reference',
}

export default TermCategory;
